import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

/**
 * Asks the API to send the password reset email.
 *
 * It used to go straight to Firebase, which composed a plain unbranded
 * message linking to smatchy-cc737.firebaseapp.com. The API now mints the
 * same link with the Admin SDK and sends it through our own template, in the
 * person's language.
 *
 * Written by hand rather than through the generated client: the route is
 * newer than the last generation of the SDK.
 *
 * The API answers the same way whether or not the address has an account, so
 * nothing here can tell them apart either. A failure of Firebase or of the
 * mailer, on the other hand, comes back as an error and must be shown: the
 * email is not on its way.
 */
@Injectable({ providedIn: 'root' })
export class PasswordResetService {
  private readonly http = inject(HttpClient);

  send(email: string, language?: string): Observable<{ handled: true }> {
    return this.http.post<{ handled: true }>(`${environment.api}/api/v1/auth/password-reset`, {
      email,
      language,
    });
  }
}
